import React, { Component } from 'react';
import './DrugBoxCard.css';
import Card from '../../../components/card/Card';
import history from '../../../history';
import utils from '../../../utils/utils';
import models from '../../../model/models';
import Input from '../../../inputs/input/Input';
import Button from '../../../components/button/Button';
import Popup from '../../../components/popup/Popup';
import CreateDrugBoxCard from '../createDrugBoxCard/CreateDrugBoxCard';
import CardHeader from '../../../components/cardHeader/CardHeader';
import Icon from "../../../components/icon/Icon";
import SortableTable from "../../../components/sortableTable/SortableTable";
import { Link } from '@material-ui/core';
import ToggleSetting from "../../../components/toggleSetting/ToggleSetting";


export default class DrugBoxCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			drug_boxes: [],
			creating: false,
			search: '',
			displayArchived: false
		};
		this.storageKey  = 'drugBoxSortPreference';
		this.sortTableOptions = {
			loadSortConfig: () => {
				const item = localStorage.getItem(this.storageKey);
				if (item) return JSON.parse(item);
				return { key: 'Name', direction: 'asc' };
			},
			onSortConfigSet: ((config) => localStorage.setItem(this.storageKey, JSON.stringify(config)))
		}
	}

	componentDidMount = () => {
		this.subscribeId = models.drug_box.onChange(this._boxesChanged);
	};

	componentWillUnmount = () => {
		models.drug_box.unsubscribe(this.subscribeId);
	};

	_boxesChanged = () => {
		let drug_boxes = models.drug_box.objs();
		this.setState({ drug_boxes });
	};

	_searchChange = (value) => {
		this.setState({ search: value });
	};

	_showPopup = () => {
		this.setState({ creating: true });
	};

	_hidePopup = () => {
		this.setState({ creating: false });
		setTimeout(() => {
			models.drug_box.refreshData().then();
		}, 1000);
	};

	_showBox = (id) => {
		history.navigate('/drug_box/' + id);
		this._hidePopup();
	}

	_renderPopup = () => {
		return (
			<Popup show={this.state.creating} onClose={this._hidePopup}>
				<CreateDrugBoxCard onClose={this._hidePopup} onCreate={this._showBox} />
			</Popup>
		);
	}

	getDrugBoxes = () => {
		const {displayArchived} = this.state;
		const {search = '', drug_boxes: drugBoxes = {}} = this.state
		return Object.entries(drugBoxes)
			.map(([_, drugBox]) => drugBox)
			.map(drugBox => ({...drugBox, isArchived: models.drug_box.isArchived(drugBox)}))
			.filter(({isArchived}) => displayArchived || !isArchived)
			.map(({id: drugBoxId, name, barcode_id = '', unit__name, last_checked_by, last_checked_on, isArchived}) => {
				const nameDisplay = isArchived ? (
					<>
						<div style={{display: 'inline-block', verticalAlign: 'middle', marginRight: '5px'}}>
							<Icon className="disabled icon" size="x-small" name="block"/>
						</div>
						<span style={{verticalAlign: 'middle'}}>{name}</span>
					</>
				) : <Link onClick={() => {history.navigate(`/drug_box/${drugBoxId}`)}}>{name}</Link>

				// Setting default to Number.NEGATIVE_INFINITY ensure that invalid or empty dates
				// are sorted to the bottom when sorting descending so that you can sort descending
				// and see the most recent date at the top.
				const date = utils.server_to_client_date(last_checked_on);
				const checkedOnValue = utils.is_date(date) ? date.getTime() : Number.NEGATIVE_INFINITY;
				const checkedOnDisplayDate = utils.display_date(utils.server_to_client_datetime(last_checked_on));
				const checkedOnDisplay = (<>{checkedOnDisplayDate}</>);

				return {
					data: [
						{column: "Name", value: name, children: nameDisplay},
						{column: "Code", value: barcode_id.toUpperCase()},
						{column: "Unit", value: unit__name},
						{
							column: "Last Checked",
							value: checkedOnValue,
							children: checkedOnDisplay,
							searchValue: checkedOnDisplayDate
						},
						{column: "Checked By", value: last_checked_by}
					]
				}
			})
			// Apply search filter based on the displayed values
			.filter(drugBox => {
				const {data = []} = drugBox
				const candidates = data.map(({value, searchValue}) => searchValue || value).filter(v => typeof v === 'string').map(v => v.toLowerCase())
				return candidates.some(candidate => candidate.includes(search.toLowerCase()))
			})
	}

	_setDisplayArchived = ({target: {checked}}) => {
		this.setState({displayArchived: checked});
	}

	render() {
		return (
			<Card className="g-drug-box-card">
				<div className="top-row">
					<CardHeader>Drug Boxes</CardHeader>
					<Input iconName="icon-search" placeholder="Search" onChange={this._searchChange} />
					<Button color="white" bg="blue large" onClick={this._showPopup}>
						Create
					</Button>
				</div>
				<ToggleSetting className='view-archived view-archived-boxes' labelPlacement='end' onChange={this._setDisplayArchived} />
				<SortableTable data={this.getDrugBoxes()} options={this.sortTableOptions} />
				{this._renderPopup()}
			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/unitListPage/drugBoxCard/DrugBoxCard.jsx